/**
 * @generated SignedSource<<ef47c8feb5b4d066cb98121a80e0610d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportFeedsTableRowFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly product: {
    readonly name: string;
  } | null;
  readonly totalComments: number;
  readonly totalReactions: number;
  readonly " $fragmentType": "AdminMembersReportFeedsTableRowFragment";
};
export type AdminMembersReportFeedsTableRowFragment$key = {
  readonly " $data"?: AdminMembersReportFeedsTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportFeedsTableRowFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "organizationMembershipId",
    "variableName": "organizationMembershipId"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organizationMembershipId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminMembersReportFeedsTableRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "totalComments",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "totalReactions",
      "storageKey": null
    }
  ],
  "type": "Feed",
  "abstractKey": null
};
})();

(node as any).hash = "84e7447ee630ec55cf4c4c486f1e51de";

export default node;
